export default __webpack_public_path__ + "static/media/icon-telha.23afe834.svg";